'use strict';

import Constants from '../constants.js';
import ObjectAssign from 'object-assign';

const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    hasError: {},
    help: {},
    success: undefined,
    message: undefined,
    status: undefined,
    oadmin_id: undefined,
    organization_id: undefined,
    order: {}
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.POST_TOKEN_AND_ORGANIZATION) {

        return ObjectAssign({}, state, {
            loading : true,
            hydrated : false
        });

    }

    if (action.type === Constants.POST_TOKEN_AND_ORGANIZATION_RESPONSE) {

        if ( action.err) {
            let message = 'Error';
            if (action.response){
                message = action.response.message;
            }

            return ObjectAssign({}, state, {
                loading: false,
                hydrated: true,
                message
            });
        }

        const response = action.response;
        if ( !response.success ) {
            return ObjectAssign({}, state, {
                error: true,
                loading: false,
                hydrated: true,
                success: false,
                message: response.message,
                status: response.status
            });
        }

        return ObjectAssign({}, state, {
            error : undefined,
            loading: false,
            success: true,
            message: 'Purchase Complete',
            oadmin_id : response.oadmin_id,
            organization_id : response.organization_id,
            status: response.status,
            order: response.order
        });
    }

    return state;
};


export default reducer;
